import { render, staticRenderFns } from "./OneTransfer.vue?vue&type=template&id=1e95f0ca&scoped=true&"
import script from "./OneTransfer.vue?vue&type=script&lang=js&"
export * from "./OneTransfer.vue?vue&type=script&lang=js&"
import style0 from "./OneTransfer.vue?vue&type=style&index=0&id=1e95f0ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e95f0ca",
  null
  
)

export default component.exports